import schema from './schema'

export default {
  modelActions: {},
  schema:  schema
};
